import styled from 'styled-components';

export default styled.div`
    & .select-prefix {
        min-width: 80px;
    }
`;
